import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { PersonasService } from "../../servicios/personas.service";
import { CatCallesService } from "../../servicios/cat-calles.service";
import { CatColoniasService } from "../../servicios/cat-colonias.service";
import { CatMunicipiosService } from "../../servicios/cat-municipios.service";
import { CatEstadosService } from "../../servicios/cat-estados.service";
import { CatTipoPersonasService } from "../../servicios/cat-tipo-personas.service";
import { CatRegimenFiscalService} from "../../servicios/cat-regimen-fiscal.service"
import { CatTipoDocumentosService } from "../../servicios/cat-tipo-documentos.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Personas,CatRegimenFiscal,CatCalles,CatColonias,CatMunicipios,CatEstados,CatTipoPersonas, CatTipoDocumentos, AguaDescuentos, RAguasPersonas, CatConceptos } from "../../entidades/entidades";
import { filter } from 'rxjs/operators';
import { AguaDescuentosService } from "../../servicios/agua-descuentos.service";
import { RAguasPersonasService} from "../../servicios/r-aguas-personas.service"
import { CatConceptosService} from "../../servicios/cat-conceptos.service"


@Component({
  selector: "app-personas",
  templateUrl: "./personas.component.html",
  styleUrls: ["./personas.component.css"]
})
export class PersonasComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catCalles: CatCalles[] = [];
  catColonias: CatColonias[] = [];
  catMunicipios: CatMunicipios[] = [];
  catEstados: CatEstados[] = [];
  catTipoPersonas: CatTipoPersonas[] = [];
  personasForm: FormGroup;
  condicionalp: boolean;
  valEditPerson = true;
  valEdit = false;
  selectedValue: string = '1';
  disableForm = false;
  reactificacion: boolean = false;
  regimenFiscal= new CatRegimenFiscal();
  catRegimenFiscal:CatRegimenFiscal[] = [];
  catTipoDocumentos: CatTipoDocumentos[] = [];
  tipoDocumento = new CatTipoDocumentos();
  selectedDate: Date = new Date();
  padronPersonas: boolean = false;
  idPersona: number;
  idDescuento: number;
  conceptoDescuento: string;

  


  @Input('readOnly') readOnly: boolean;    
  @Input("personas") personas: Personas;

  @Output("personasOutput") personasOutput: EventEmitter<Personas>;
  @ViewChild('campañaDescuento') campañaDescuento: ElementRef;
     


  constructor(
    private formBuilder: FormBuilder,
    private personasService: PersonasService,
    private catCallesService: CatCallesService,
    private catColoniasService: CatColoniasService,
    private catMunicipiosService: CatMunicipiosService,
    private catEstadosService: CatEstadosService,
    private catTipoPersonasService: CatTipoPersonasService,
    private catRegimenFiscalService:CatRegimenFiscalService,
    private catTipoDocumentosService: CatTipoDocumentosService,
    private router: Router,
    private aguaDescuentosService: AguaDescuentosService,
    private rAguasPersonasService: RAguasPersonasService,
    private catConceptosService: CatConceptosService,


    private route: ActivatedRoute
  ) {
    this.personasOutput = new EventEmitter();
  }

  ngOnInit() {
    this.getAllCatCalles();
    this.getAllCatColonias();
    this.getAllCatMunicipios();
    this.getAllCatEstados();
    this.getAllCatTipoPersonas();
    this.getAllRegimenFiscal();
    this.getAllDocumentos();
    this.getAllDescuento();

    this.personasForm = this.formBuilder.group({
      id: [undefined],
      razonSocial: [undefined, [Validators.maxLength(200)]],
      nombre: [undefined, [Validators.maxLength(230)]],
      primerApellido: [undefined, [Validators.maxLength(30)]],
      segundoApellido: [undefined, [Validators.maxLength(30)]],
      correoElectronico: [undefined, [Validators.maxLength(50), Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
      correoElectronico2: [undefined, [Validators.maxLength(50), Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)]],
      rfc: [undefined, [this.validarRFC]],
      telefono: [undefined, [Validators.maxLength(10), Validators.pattern(/^\d{10}$/)]],
      telefono2: [undefined, [Validators.maxLength(10), Validators.pattern(/^\d{10}$/)]],
      idTipoPersona: [1],
      folioIdentificacion: [undefined, [Validators.maxLength(20)]],
      fechaNacimiento: [undefined],
      idRegimenFiscal:[0],
      idTipoDocumento: [0],
      vencimiento: [Date],
      domicilio: [undefined],
      direccionEnvio: [undefined]
    });
    if (this.personas) {
      this.personasForm.patchValue(this.personas);
      // Valor recibido del servidor
      //const isoDate = (this.personas?.vencimiento).toString();
      const isoDate = (this.personas?.vencimiento ?? "").toString();

      // Extraer solo la parte de la fecha
      const formattedDate = isoDate.split('T')[0];
      // Asignar al formulario (ejemplo con Angular FormControl)
      this.personasForm.get('vencimiento')?.setValue(formattedDate);
      this.reactificacion = true;
      let aux = Object.values(this.personas);
      if (aux[15] == 2) {
        this.personasForm.patchValue({
          idTipoPersona: 2
        });
        this.valEditPerson = false;
      }
      else {
        this.personasForm.patchValue({
          idTipoPersona: 1
        }); 
        this.valEditPerson = true;
      }
          // Forzar validación en todos los controles
      Object.keys(this.personasForm.controls).forEach((campo) => {
        this.personasForm.controls[campo].markAsTouched();
        this.personasForm.controls[campo].updateValueAndValidity();
      });
    }
    else {
      this.personasForm.patchValue({
        idTipoPersona:1
      });
      this.valEditPerson = true;
      this.reactificacion = false;
    }
    if (this.readOnly){
      this.personasForm.disable();
    }
    else{
      this.personasForm.enable();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["personas"] && changes["personas"].currentValue) {
      console.log("ngOnChanges", this.personas); // Aquí ya debería tener datos
    }
  }
  CondicionalP() {
    if (this.personasForm.value.idTipoPersona == "1") {
  
      this.personasForm.patchValue({
        //razonSocial: null,
        idTipoPersona: 1
      });
      this.valEditPerson = true;

    } else

      if (this.personasForm.value.idTipoPersona == "2") {
       
        this.personasForm.patchValue({
          //nombre: null,
          //primerApellido: null,
          //segundoApellido: null,
          idTipoPersona: 2
        });
        this.valEditPerson = false;
      }
    }

  resetForm() {
    this.personasForm.reset();
  }
  validarRFC(control: FormControl): { [s: string]: boolean } {
    if(!control.value) {return null;}
    const rfcPatternPersonaFisica = /^[a-zA-Z]{4}\d{6}[a-zA-Z0-9]{3}$/;
    const rfcPatternPersonaMoral = /^[a-zA-Z]{3}\d{6}[a-zA-Z0-9]{3}$/;
    
    const value = control.value.toUpperCase();

    if (!rfcPatternPersonaFisica.test(value) && !rfcPatternPersonaMoral.test(value)) {
      return { 'invalidRFC': true };
    }

    return null;
  }


  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async insertaPersona() {
    try {
      this.personas = this.personasForm.value;
      let aux = this.personasForm.value.idTipoPersona;
      //Se comprueba si el idTipoPersona si es String se cambia a Number
      //Esto para ponerlo default
      if (typeof (aux) == "string") {
        this.personasForm.patchValue({
          idTipoPersona: 1
        });
      }
      if (this.personasForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      //this.personas = this.personasForm.value.itTipo;


      this.personas.id = 0;
      await this.addPersonas(this.personas);

      this.personasOutput.emit(this.personas);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarPersonas ");
    }
  }
  async actualizaPersona() {
    try {
      this.personas = this.personasForm.value;
      let aux = this.personasForm.value.idTipoPersona;
      /////Se comprueba si el idTipoPersona si es String se cambia a Number
      /////Esto para ponerlo default
      if (typeof (aux) == "string") {
        this.personasForm.patchValue({
          idTipoPersona: 1
        });
      }
      if (this.personasForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      if (this.personas.id) {
        this.updatePersonas(this.personas);

      }
      this.personasOutput.emit(this.personas);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarPersonas ");
    }
  }
  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addPersonas(personas) {
    try {
      const datoretorno = await this.personasService.add(personas).toPromise();
      this.personas = datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addPersonas");
    }
  }

  async updatePersonas(personas: Personas) {
    try {
      const datoRetorno = await this.personasService
        .update(personas)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updatePersonas");
    }
  }

  async deletePersonas(personas: Personas) {
    try {
      const datoRetorno = await this.personasService
        .delete(personas.id)
        .toPromise();
      this.getAllPersonas();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deletePersonas");
    }
  }

  async getPersonas(id: number) {
    try {
      this.borrarDatos();
      const datoRetorno = await this.personasService.getSingle(id).toPromise();
      this.personasForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPersonas");
    }
  }

  async getAllPersonas() {
    try {
      const datoRetorno = await this.personasService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllPersonas");
    }
  }

  async getAllCatCalles() {
    try {
      const datoRetorno = await this.catCallesService.getAll().toPromise();
      this.catCalles = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatCalles");
    }
  }

  async getAllCatColonias() {
    try {
      const datoRetorno = await this.catColoniasService.getAll().toPromise();
      this.catColonias = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatColonias");
    }
  }

  async getAllCatMunicipios() {
    try {
      const datoRetorno = await this.catMunicipiosService.getAll().toPromise();
      this.catMunicipios = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatMunicipios");
    }
  }

  async getAllCatEstados() {
    try {
      const datoRetorno = await this.catEstadosService.getAll().toPromise();
      this.catEstados = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstados");
    }
  }

  async getAllCatTipoPersonas() {
    try {
      const datoRetorno = await this.catTipoPersonasService
        .getAll()
        .toPromise();
      this.catTipoPersonas = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatTipoPersonas");
    }
  }
  async getAllRegimenFiscal() {
    try {
      const datoRetorno = await this.catRegimenFiscalService.getAll().toPromise();
      this.catRegimenFiscal = datoRetorno;
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getCatUsoCfdi");
    }
  }

  async getAllDocumentos(){
    try{
        const datoRetorno = await this.catTipoDocumentosService.getAll().toPromise();
        this.catTipoDocumentos = datoRetorno;
    }catch (e){
      if (e.response) {
          throw { message: e.response.data };
      } else {
          throw e;
      }
    }finally{
      console.log("Paso por tipo de Documento");
    }
  }

  async getAllDescuento(){
      try{
          if (!this.personas) {return;}
          const datoRetorno = await this.rAguasPersonasService.getSingleByPersona(this.personas.id).toPromise();
          //this.idPersona = datoRetorno.idAgua;

          const valorRetorno = await this.aguaDescuentosService.getSingle(datoRetorno.idAgua).toPromise();
          if(valorRetorno.length > 0){
            this.idDescuento = valorRetorno[0].idConcepto;
            const retorno = await this.catConceptosService.getSingle(this.idDescuento).toPromise();
            this.conceptoDescuento = retorno.descripcion
            this.campañaDescuento.nativeElement.value = this.conceptoDescuento;  
          }
      }catch (e){
        if (e.response) {
          throw { message: e.response.data };
        } else {
          throw e;
        }
      }finally{
        console.log("Paso por Descuento");
      }
  }

  async borrarDatos(){
    this.campañaDescuento.nativeElement.value = '';
  }


  async selectRegimenFiscal() {
    const idRegimenFiscal = this.personasForm.controls.id.value;
    this.regimenFiscal = this.catRegimenFiscal.find((x) => x.id === idRegimenFiscal);
  }

  async selectDocumento(){
    const idTipoDocumento = this.personasForm.controls.id.value;
    this.tipoDocumento = this.catTipoDocumentos.find((x) => x.id === idTipoDocumento);
  }

}

